//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpTableButtonCell',
  props: {
    buttons: { type: Array, default: () => [], required: true },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    primaryButton() {
      return this.buttons.filter((b) => b.primary === true)[0];
    },
    otherButtons() {
      return this.buttons.filter((b) => !b.primary);
    },
  },
  methods: {
    handleClick(button) {
      if (button.emit) {
        this.$emit(button.emit);
      }
      this.$emit('action', button.emit);
    },
  },
};
